/* The three Cash templates, ONE description — shared by Submit Cash Report (where each is entered)
   and Cash Report Approval (where each is decided), so the two screens cannot describe a report two
   ways. One row per template: the tab's words, the form that types it, the report's own lines (so
   the Preparer sees what was imported exactly as the approvers will), and which files it takes. */
import React from 'react';
import { WeeklyForm, PlanForm, MonthEndForm } from './CashForms';
import { WeeklyBody, PlanBody, ReconBody } from './CashBodies';
import { fmtDay } from './cashUi';

export const CASH_TYPES = [
  { type: 'weekly', tpl: 'Template 1', nav: 'nav.cashWeekly', Form: WeeklyForm, fileKinds: ['statement', 'balance', 'other'],
    heading: (t, d) => `${d.period.code} · ${t('cashw.weekEnding', { d: fmtDay(d.period.end) })}`,
    body: (t, d, h) => <WeeklyBody t={t} d={d} {...h} /> },
  { type: 'plan', tpl: 'Template 2', nav: 'nav.cashPlan', Form: PlanForm, fileKinds: ['other'],
    heading: (t, d) => t('xCashMp.panelHeading', { week: d.period.code }),
    body: (t, d) => <PlanBody t={t} d={d} /> },
  { type: 'monthend', tpl: 'Template 3', nav: 'nav.cashMonthEnd', Form: MonthEndForm, fileKinds: ['statement', 'balance', 'other'],
    heading: (t, d) => `${d.period.label} · ${t('cashm.monthEndOn', { d: fmtDay(d.period.end) })}`,
    body: (t, d, h) => <ReconBody t={t} d={d} {...h} /> },
];

export const cashTypeOf = (type) => CASH_TYPES.find((x) => x.type === type) || null;
